import Vue from 'vue';

Vue.filter('capitalize', (value) => value.replace(/\b(\w)/, value[0].toUpperCase()));

Vue.filter('snakeCaseToNormal', (value) => value.replace(/_/g, ' '));